// 用户取，选择方法
<template>
  <div class="selectWay fetchSelectWay">
    <!-- 流程 -->
    <userFetchFlow></userFetchFlow>

    <div class="way-list clearfix">
      <div class="list">
        <p class="title">方法1：请刷员工卡</p>
        <div class="detail clearfix">
          <div class="left-bracket"></div>
          <p class="card">员工卡</p>
          <div class="right-bracket"></div>
        </div>
      </div>

      <div class="list">
        <p class="title">方法2：打开微信扫二维码</p>
        <div class="detail clearfix">
          <div class="left-bracket"></div>
          <div class="code">
            <span
              class="text"
              v-show="QRurl === ''">二维码获取中...</span>
            <img
              :src="QRurl"
              v-show="QRurl !== ''" />
          </div>
          <div class="right-bracket"></div>
        </div>
      </div>

      <div
        class="expressFetch"
        @click="changeWrapper">取件码取件</div>
      <div
        class="expressFetch-wrapper"
        v-show="wapperStatus">
        <div class="detail">
          <p class="title">
            取件码取件
            <span
              class="close"
              @click="changeWrapper"></span>
          </p>
          <el-form class="input-box">
            <el-input
              type="number"
              placeholder="请输入手机号后四位"
              v-model="phone_no"
              oninput="if (this.value.length > 4) {this.value = this.value.slice(0, 4); }"
              clearable>
            </el-input>
            <el-input
              class="open_password"
              type="number"
              placeholder="请输入六位取件码"
              v-model="open_password"
              oninput="if (this.value.length > 6) {this.value = this.value.slice(0, 6); }"
              clearable>
            </el-input>
            <el-button
              type="primary"
              class="btn-fetch"
              @click="pickup('3')">取件</el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userFetchFlow from './userFetchFlow'
import {
  // checkUserInfo,
  pickup,
  getWeiXinQRcode,
  showToast,
  showLoading,
  hideLoading
} from '../../../../static/mailBox/js/request.js'
// import {
//   useSocket
// } from '../../../../static/mailBox/js/socket.js'

export default {
  name: 'mailBoxFetchSelectWay',
  components: {
    userFetchFlow
  },
  data () {
    return {
      cardNum: '',
      phone_no: '',
      open_password: '',
      wapperStatus: false,
      QRurl: '',
      authID: '',
      authPhone: ''
    }
  },
  created () {
    this.getWeiXinQRcode()
    // 连接websocket
    // useSocket()
  },
  mounted () {
    this.$store.state.mail_type = 'staff'
    // console.log(this.$store.state.mail_socketData)
  },
  watch: {
    // 监听socketData,数据返回（卡号、快递单号、二维码验证结果）
    // '$store.state.mail_socketData': function (newVal) {
    //   console.log('newVal', newVal)
    //   if (newVal !== '') {
    //     this.processSocketData(newVal)
    //   }
    // }
  },
  methods: {
    // 处理socketData，验证身份
    processSocketData: function (data) {
      let vm = this
      // messageType为返回的数据类型。ad01--卡号，ab01--快递单号，auth--二维码验证
      let messageType = data.messageType
      let checkData
      if (messageType === 'ad01' && data.cabinet_id === vm.$store.state.mail_cabinet_id) {
        // 刷卡
        checkData = {
          // checkType: 1-IC卡号；2-手机号。
          checkType: '1',
          checkInfo: data.ICCardNo
        }
        vm.cardNum = data.ICCardNo
      } else if (messageType === 'auth') {
        // 二维码验证身份
        checkData = {
          // checkType: 1-IC卡号；2-手机号。
          checkType: '2',
          checkInfo: data.authPhone
        }
        vm.authPhone = data.authPhone
      } else {
        showToast('请刷卡或验证二维码')
        return
      }
      // vm.checkUserInfo(checkData)
    },
    // 获取小程序码
    getWeiXinQRcode: async function () {
      let vm = this
      let res = await getWeiXinQRcode()
      console.log('res', res)
      if (res.meta.code === 200) {
        vm.authID = res.body.authID
        setTimeout(function () {
          vm.QRurl = res.body.QR_url
        },
        1000)
      }
    },
    // 检查用户身份（取件）
    checkUserInfo: async function (data) {
      let vm = this
      console.log('data', data)
      showLoading('身份验证中')
      let res = await checkUserInfo(data)
      hideLoading()
      if (res.meta.code === 200) {
        // 若是快递部门信息
        if (res.body.userGroupID === '-2') {
          showToast('用户信息不存在')
          return
        }
        // checkType: 1--IC卡号；2--手机号。pickupType: 1--手机号，2--IC卡号，3--手机尾号+取件码。
        let pickupType = data.checkType === '1' ? '2' : '1'
        vm.pickup(pickupType)
      } else {
        showToast(res.meta.message)
      }
    },
    // 取件 pickupType: 1-手机号，2-IC卡号，3-手机尾号+取件码
    pickup: async function (pickupType) {
      let vm = this
      let data = {}
      data.pickupType = pickupType
      if (pickupType === '1') {
        // 手机号取件
        data.pickupInfo = {
          receiverPhone: this.authPhone,
          cabinet_id: this.$store.state.mail_cabinet_id,
          box_no: null
        }
        console.log('tag', '')
      } else if (pickupType === '2') {
        // 卡号取件
        data.pickupInfo = {
          receiverICCard: this.cardNum,
          cabinet_id: this.$store.state.mail_cabinet_id,
          box_no: null
        }
      } else if (pickupType === '3') {
        // 手机号+取件码取件
        // 验证手机号
        if (this.phone_no === '' || (this.phone_no !== '' && this.phone_no.length !== 4)) {
          showToast('请输入手机号后四位')
          return
        }
        // 验证取件码
        if (this.open_password === '') {
          showToast('请输入六位取件码')
          return
        } else {
          if (this.open_password.length !== 6) {
            showToast('请输入正确的六位取件码')
            return
          }
        }
        data.pickupInfo = {
          open_password: this.open_password,
          phone_no: this.phone_no,
          cabinet_id: this.$store.state.mail_cabinet_id
        }
      }

      let res = await pickup(data)
      console.log('res', res)
      vm.goOpenBox(res, pickupType)
    },
    // 显示或隐藏选择取件框---选择手机后四位+取件码取件
    changeWrapper: function () {
      this.wapperStatus = !(this.wapperStatus)
    },
    // 跳转到打开箱格页面
    goOpenBox: function (res, pickupType) {
      console.log('code', res.meta.code)
      if (res.meta.code === 4002) {
        // 有多个箱格
        let boxList = res.body
        for (let i in boxList) {
          // showStatus表示箱格状态。false为未打开，true为已打开。
          this.$set(boxList[i], 'showStatus', false)
        }
        this.$router.push({
          // 你要跳转的地址
          path: '/userFetch/openboxList',
          query: {boxList: boxList, pickupType: pickupType}
        })
      } else {
        // 只有一个箱格
        let newRes = res
        console.log('newRes', newRes)
        if (res.meta.code === 200) {
          newRes.body.showStatus = true
          if (pickupType === '3') {
            newRes.body.deliverInfo = res.body
          }
        } else {
          console.log('code', res.meta.code)
          newRes.body = {}
          newRes.body.showStatus = false
          newRes.body.message = res.meta.message
        }
        this.$router.push({
          // 你要跳转的地址
          path: '/mailBox/userFetch/openBoxOne',
          query: {box: newRes.body, pickupType: pickupType
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.expressFetch{
  float: left;
  width: 100%;
  color: #4babfe;
  text-align: center;
  font-size: 0.5rem;
  margin-top: 0.7rem;
  text-decoration: underline;
  position: relative;
  z-index: 10;
}

.expressFetch-wrapper{
  width: 100%;
  height: 100%;
  background-color: rgba(0,
  0,
  0,
  0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}

.expressFetch-wrapper .detail{
  width: 5.5rem;
  height: 5rem;
  margin: 2.9rem auto 0;
  border-radius: 0.1rem;
  background-color: #ffffff;
}

.expressFetch-wrapper .detail .title{
  line-height: 0.88rem;
  color: #ffffff;
  font-size: 0.34rem;
  text-align: center;
  background-color: #0d508f;
  border-top-left-radius: 0.1rem;
  border-top-right-radius: 0.1rem;
  position: relative;
}

.expressFetch-wrapper .detail .close{
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  background: url(/static/images/icon/close-white.png) center no-repeat;
  background-size: 100%;
  position: absolute;
  right: 0.15rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.expressFetch-wrapper .detail .input-box{
  padding: 0.7rem 0.31rem 0;
  margin: 0 0.27rem;
  position: relative;
  z-index: 99;
}

.expressFetch-wrapper .detail .input-box .el-input{
  width: 100%;
  display: block;
  margin-bottom: 0.16rem;
}

.expressFetch-wrapper .detail .btn-fetch{
  display: block;
  width: 1.6rem;
  height: 0.7rem;
  line-height: 0.7rem;
  padding: 0;
  margin: 0.25rem auto 0;
  font-size: 0.28rem;
  position: relative;
  z-index: 99;
}

.selectWay{
  width: 100%;
}

.selectWay .way-list{
  width: 15.27rem;
  margin: 1.15rem auto 0;
}

.selectWay .way-list .list{
  float: left;
  width: 6.14rem;
  text-align: center;
}

.selectWay .way-list .list:first-child{
  width: 7.66rem;
  margin-right: 1.47rem;
}

.selectWay .way-list .list .title{
  font-size: 0.45rem;
  font-weight: bold;
  line-height: 0.5rem;
  margin-bottom: 0.4rem;
}

.selectWay .way-list .list .detail{
  width: 100%;
  height: 4.85rem;
}

.selectWay .way-list .list .detail .left-bracket,
.selectWay .way-list .list .detail .right-bracket{
  float: left;
  width: 0.54rem;
  height: inherit;
  border: 0.04rem solid #ffffff;
}

.selectWay .way-list .list .detail .left-bracket{
  border-right: none;
}

.selectWay .way-list .list .detail .right-bracket{
  border-left: none;
}

.selectWay .way-list .list .detail .card,
.selectWay .way-list .list .detail .code{
  float: left;
  height: 3.52rem;
  line-height: 3.52rem;
  font-size: 0.4rem;
}

.selectWay .way-list .list .detail .card{
  width: 5.75rem;
  margin: 0.66rem 0.415rem 0;
  background-color: #efefef;
}

.selectWay .way-list .list .detail .code{
  width: 3.52rem;
  margin: 0.66rem 0.77rem 0;
}

.selectWay .way-list .list .detail .code img{
  display: block;
  width: 3.52rem;
  height: 3.52rem;
  position: relative;
  z-index: 9999;
}
/* .selectWay{
  width: 100%;
  padding: 0 3%;
}

.selectWay .way-list{
  width: 100%;
  padding-top: 50px;
}

.selectWay.fetchSelectWay .way-list .list{
  float: left;
  width: 5.2rem;
  text-align: center;
  margin-right: 0.86rem;
}

.selectWay .way-list .list:nth-child(2){
  width: 4.12rem;
}

.selectWay .way-list .list:nth-child(3){
  margin-right: 0;
}

.selectWay .way-list .list .title{
  font-size: 0.45rem;
  font-weight: bold;
  line-height: 0.65rem;
  margin-bottom: 0.3rem;
}

.selectWay .way-list .list .detail{
  width: 100%;
  text-align: center;
}

.selectWay .way-list .list .detail .left-bracket,
.selectWay .way-list .list .detail .right-bracket{
  float: left;
  width: 0.38rem;
  height: 3.44rem;
  border: 0.04rem solid #ffffff;
}

.selectWay .way-list .list .detail .left-bracket{
  border-right: none;
}

.selectWay .way-list .list .detail .right-bracket{
  border-left: none;
}

.selectWay .way-list .list .detail .card,
.selectWay .way-list .list .detail .code{
  float: left;
  height: 2.48rem;
  line-height: 2.48rem;
  background-color: #efefef;
  font-size: 0.3rem;
}

.selectWay .way-list .list .detail .card{
  width: 3.88rem;
  margin: 0.5rem 0.28rem 0;
}

.selectWay .way-list .list .detail .code{
  width: 2.48rem;
  margin: 0.5rem 0.44rem 0;
}

.selectWay .way-list .list .detail .input-box{
  float: left;
  width: 3.9rem;
  margin: 0 0.27rem;
  padding-top: 0.5rem;
  position: relative;
  z-index: 99;
}

.selectWay .way-list .list .detail .input-box .el-input{
  width: 100%;
  display: block;
  margin-bottom: 0.2rem;
}

.selectWay .way-list .list .detail .btn-fetch{
  display: block;
  width: 1.6rem;
  height: 0.58rem;
  line-height: 0.58rem;
  padding: 0;
  margin: 0.1rem auto 0;
  position: relative;
  z-index: 99;
} */

</style>



// WEBPACK FOOTER //
// src/components/mailBox/userFetch/selectWay.vue